import React, {Component} from "react"
import {Alert, Modal, ModalBody, ModalHeader,} from "reactstrap";
import PropTypes from "prop-types";

class ApproveRemoveAcceptModal extends Component {
    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                scrollable={true}
                backdrop={'static'}
                id="staticBackdrop"
            >
                <ModalHeader toggle={this.props.onCancel}>
                    [#{this.props.approve ? this.props.approve.id : ''}] 입장 허가 제거
                </ModalHeader>
                <ModalBody>
                    <Alert color="warning" role="alert">
                        <b>아래 사용자의 레쿠 소통방 입장 허가를 제거할까요?</b>
                        <br/><br/>
                        트위터 닉네임: {this.props.approve ? this.props.approve.twitterName : ''}
                        <br/>
                        트위터 아이디: @{this.props.approve ? this.props.approve.twitterUsername : ''}
                        <br/><br/>
                        <b>입장 허가 제거 시 초기 입장 신청과 동일한 상태로 변경됩니다.</b>
                    </Alert>
                </ModalBody>
                <div className="modal-footer">
                    <button type="button" className="btn btn-light"
                            onClick={() => this.props.onCancel()}>
                        취소
                    </button>
                    <button type="button" className="btn btn-warning"
                            onClick={() => this.props.onSubmit('')}>
                        입장 허가 제거
                    </button>
                </div>
            </Modal>
        )
    }
}

ApproveRemoveAcceptModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    approve: PropTypes.object,

    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default ApproveRemoveAcceptModal;
